
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ItemsActionName, ItemsActionNames } from '@/definitions/app/item.actions.name';
import { ModelAclResult } from '@/store/acl/types';
import { configModule } from '@/store/config';
import { NButton } from '@/uikit';
import NForm from '@/uikit/forms/NForm.vue';
import { ImageViewerActions } from '@/uikit/image-viewer/types';
import NThumbnail from '@/uikit/thumbnail/NThumbnail.vue';
import AcknowledgeInfo from '@/components/common/AcknowledgeInfo.vue';
import Attributes from '@/components/common/Attributes.vue';
import CameraLabels from '@/components/common/CameraLabels.vue';
import Acknowledge from '@/components/common/deprecated/Acknowledge.vue';
import { getItemCommonFields } from '@/components/common/get-item-common-fields';
import SimpleReaction from '@/components/common/SimpleReaction.vue';
import { WatchListItemMarkers } from '@/components/common/watch-list-types';
import WatchListsGroup from '@/components/common/WatchListsGroup.vue';
import { EventView } from '@/components/events/adapter';
import EventItemAttributeLineCross from '@/components/events/EventItemAttributeLineCross.vue';
import { AnyEpisode, AnyEvent, EventOrEpisode } from '@/components/events/types';
import MatchedCardInfo from '@/pages/events/MatchedCardInfo.vue';

@Options({
  name: 'EventInfoSidebarContent',
  components: {
    Acknowledge,
    AcknowledgeInfo,
    Attributes,
    CameraLabels,
    EventItemAttributeLineCross,
    MatchedCardInfo,
    NButton,
    NForm,
    NThumbnail,
    SimpleReaction,
    WatchListsGroup
  }
})
export default class EventInfoSidebarContent extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: EventOrEpisode;

  @Prop({ type: Object, required: true })
  readonly eventView!: EventView;

  @Prop({ type: String, required: true })
  readonly objectType!: string;

  @Prop({ type: String, required: true })
  readonly cardType!: string;

  @Prop({ type: Object, required: true })
  readonly modelAcl!: ModelAclResult;

  get hasAttributes(): boolean {
    return !!Object.keys(this.eventView.features || this.eventView.faces_features || this.eventView.bodies_features || this.eventView.cars_features || {})
      .length;
  }

  get hasLineCross() {
    return (this.item as AnyEpisode).lines?.length || (this.item as AnyEvent).line;
  }

  get extraAttributesSlot() {
    // order matter
    if (this.eventView.cars_features) return 'cars-extra-attributes';
    if (this.eventView.bodies_features) return 'bodies-extra-attributes';
    return 'faces-extra-attributes';
  }

  get attributesItems() {
    return {
      faces: { display: !!this.eventView.faces_features, features: this.eventView.faces_features },
      bodies: { display: !!this.eventView.bodies_features, features: this.eventView.bodies_features },
      cars: { display: !!this.eventView.cars_features, features: this.eventView.cars_features }
    };
  }

  get marker() {
    return WatchListItemMarkers.Circle;
  }

  get infoFields() {
    return getItemCommonFields();
  }

  get hasPlay() {
    return configModule.config.vms?.enabled;
  }

  showFullscreen() {
    this.eventView['actions'] = [ImageViewerActions.Detect];
    this.$emit('action', ItemsActionNames.ShowFullScreen, this.eventView);
  }

  handleCameraAction(action: ItemsActionName, payload: any) {
    this.$emit('action', action, payload);
  }
}
